import type { FC } from "react"
import { ActivityTypeUrgencyBannerTypeEnum } from "~/graphql"
import Fire from "~/icons/Fire"

interface Props {
  numberOfViewers: number
  bannerType?: ActivityTypeUrgencyBannerTypeEnum | null
  bannerText?: string | null
}

const ViewerUrgencyBanner: FC<Props> = ({
  numberOfViewers,
  bannerType,
  bannerText
}) => {
  if (bannerType === ActivityTypeUrgencyBannerTypeEnum.HIDDEN) {
    return null
  }

  if (bannerType === ActivityTypeUrgencyBannerTypeEnum.CUSTOM && bannerText) {
    return (
      <div className="flex gap-2 items-center px-2">
        <Fire className="w-4 h-4 text-red-500 flex-shrink-0" />
        <p className="text-base">{bannerText}</p>
      </div>
    )
  }

  return (
    <div className="flex gap-2 items-center px-2">
      <img src="/images/eyeball.png" alt="Urgency Banner" className="w-4 h-3" />
      <p className="text-base">{numberOfViewers} People Viewing This Event</p>
    </div>
  )
}

export default ViewerUrgencyBanner
